import * as React from "react"

const AnnouncementBanner = () => {
  return (
    <div className="bg-yellow-200 text-black py-3 px-4 text-center fixed top-0 left-0 right-0 z-[50]">
      <p className="mobile:text-xl leading-tight">
        Infer is now part of Frisbii. Read all about it{" "}
        <a
          href="https://frisbii.com/blog/frisbii-acquires-ai-predictive-analytics-specialist-infer-expands-its-expertise-in-data-driven-revenue-optimization/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-yellow-400 transition-colors font-semibold"
        >
          here
        </a>.
      </p>
    </div>
  )
}

export default AnnouncementBanner 